import { PropertyCaption } from '../../PropertyCaption';
import { TextInput } from '../../TextInput';

import type { ControlRenderProps, TextControlSetting } from '../ControlTypes';

export const TextControl = ({
  control,
  modifyProperty,
  unifiedValue,
}: ControlRenderProps<TextControlSetting>) => {
  const value = typeof unifiedValue === 'string' ? unifiedValue : '';

  return (
    <>
      <PropertyCaption>{control.label}</PropertyCaption>
      <TextInput
        text={value}
        modifyElement={(text: string) => {
          modifyProperty(control.elementPaths, control.property, text);
        }}
      />
    </>
  );
};
